module.exports = "<div class=\"coming-soon\">\n    <a class=\"hitchd-logo\" routerLink=\"/registry\">\n      <img src=\"/assets/public/images/hitchd-logo-light.svg\" class=\"\" alt=\"Hitchd Logo\">\n    </a>\n\n  <div class=\"wrapper\" >\n    <h1>Our Hitchd experience is still preparing for takeoff.</h1>\n    <p>(Trust us — it's worth the wait!)</p>\n\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/registry404/registry404.component.html
// module id = ./src/app/registry404/registry404.component.html
// module chunks = main